// export const $BASE_URL = 'https://test.yjwxc.com/'; //测试
export const $BASE_URL = 'https://www.yjwxc.com/';//正式



export default {
	// $BASE_URL_img: 'https://test.yjwxc.com',//测试
	$BASE_URL_img: 'https://www.yjwxc.com',//正式
	// 登录
	login: $BASE_URL + 'api/user/login',
	// 发送注册短信验证码
	// send_code: $BASE_URL + 'home/user/send_code',
	send_code: $BASE_URL + 'api/user/send_code',
	// 注册
	register: $BASE_URL + 'api/user/register',
	//书城 首页
	bookcityIndex: $BASE_URL + 'api/index/index',
	//搜索
	search_page: $BASE_URL + 'api/index/search_page',
	//检索页
	retrieve_page: $BASE_URL + 'api/index/retrieve_page',
	//书架
	book_shelf: $BASE_URL + 'api/index/book_shelf',
	//书单
	books_list: $BASE_URL + 'api/index/books_list',
	//关注
	my_follow: $BASE_URL + 'api/index/my_follow',
	//书单详情
	books_list_detail: $BASE_URL + 'api/index/books_list_detail',
	//书单评论
	list_comment: $BASE_URL + 'api/index/list_comment',
	//添加评论
	add_comment_index: $BASE_URL + 'api/index/add_comment',
	//云锦金榜
	ranking_zb: $BASE_URL + 'api/index/ranking_zb',
	//搜索
	search_book: $BASE_URL + 'api/index/search_book',
	// 排行
	ranking_index: $BASE_URL + 'api/ranking/index',
	// 强推排行
	ranking_qt_list: $BASE_URL + 'api/ranking/ranking_qt_list',
	// 收入金榜
	ranking_sr_list: $BASE_URL + 'api/ranking/ranking_sr_list',
	// 完结金榜
	ranking_wj_list: $BASE_URL + 'api/ranking/ranking_wj_list',
	// 萌新榜
	ranking_mx_list: $BASE_URL + 'api/ranking/ranking_mx_list',
	// 月榜
	ranking_yue_list: $BASE_URL + 'api/ranking/ranking_yue_list',
	// 季榜
	ranking_ji_list: $BASE_URL + 'api/ranking/ranking_ji_list',
	// 云尼斯总榜
	ranking_yns_list: $BASE_URL + 'api/ranking/ranking_yns_list',
	// 金云朵总榜
	ranking_jyd_list: $BASE_URL + 'api/ranking/ranking_jyd_list',
	// 勤奋修仙帮
	ranking_qfxx_list: $BASE_URL + 'api/ranking/ranking_qfxx_list',
	// vip新文总榜
	ranking_vip_list: $BASE_URL + 'api/ranking/ranking_vip_list',
	// 限免首页
	xianmian_index: $BASE_URL + 'api/xianmian/xianmian',
	// 历史限免
	xianmian_old: $BASE_URL + 'api/xianmian/old_xianmian',
	//  三级分类免费完结
	thrid_free_list: $BASE_URL + 'api/xianmian/thrid_free_list',
	//  完结首页
	wanjie: $BASE_URL + 'api/wanjie/wanjie',
	//限免一键收藏
	xianmian_collect: $BASE_URL + 'api/xianmian/one_key_collect',
	//限时一分
	one_cent: $BASE_URL + 'api/xianmian/one_cent',
	//往期一分
	old_one_cent: $BASE_URL + 'api/xianmian/old_one_cent',
	//言情完结
	ranking_qywj: $BASE_URL + 'api/wanjie/ranking_qywj',
	//纯爱完结
	ranking_cawj: $BASE_URL + 'api/wanjie/ranking_cawj',
	//衍生完结
	ranking_yswj: $BASE_URL + 'api/wanjie/ranking_yswj',
	//言情半价
	ranking_qybj: $BASE_URL + 'api/wanjie/ranking_qybj',
	//纯爱半价
	ranking_cabj: $BASE_URL + 'api/wanjie/ranking_cabj',
	//衍生半价
	ranking_ysbj: $BASE_URL + 'api/wanjie/ranking_ysbj',
	//热门标签
	hot_lable_list: $BASE_URL + 'api/index/hot_lable_list',
	//热门类型
	type_list: $BASE_URL + 'api/index/type_list',
	//书本详情
	book_detail: $BASE_URL + 'api/book/book_detail',
	//批量订阅页面数据
	batch_order: $BASE_URL + 'api/book/batch_order',
	//我的书单
	my_book_list: $BASE_URL + 'api/book/my_book_list',
	//添加到书单
	add_to_list: $BASE_URL + 'api/book/add_to_list',
	//添加书单
	add_books_list: $BASE_URL + 'api/index/add_books_list',
	//阅读
	read: $BASE_URL + 'api/book/read',
	//小说评论
	book_comment: $BASE_URL + 'api/book/add_comment',
	//读者专栏收藏
	reader_collect: $BASE_URL + 'api/user/reader_collect',
	//读者书单
	reader_book_list: $BASE_URL + 'api/user/reader_book_list',
	//读者最新订阅
	reader_history: $BASE_URL + 'api/user/reader_history',
	//章节订阅
	batch_buy: $BASE_URL + 'api/book/batch_buy',
	//黑马榜
	dark_horse_ranking: $BASE_URL + 'api/index/dark_horse_ranking',
	//热门推荐
	hot_books_ranking: $BASE_URL + 'api/index/hot_books_ranking',
	//阅读历史
	read_history_ranking: $BASE_URL + 'api/index/read_history_ranking',
	//收藏列表
	collect_list_ranking: $BASE_URL + 'api/index/collect_list_ranking',
	//二级分类页面数据
	second_category_list: $BASE_URL + 'api/index/second_category_list',
	//三级分类页面数据
	third_category_list: $BASE_URL + 'api/index/third_category_list',
	//个人资料
	my_info: $BASE_URL + 'api/my/my_info',
	//我的礼物
	my_gift: $BASE_URL + 'api/my/my_gift',
	//礼物详情
	gift_detail: $BASE_URL + 'api/my/gift_detail',
	// //获取消息
	// get_user_msg: $BASE_URL + 'api/my/get_user_msg',
	//发送消息
	send_msg: $BASE_URL +'api/my/send_msg',
	//收信人名单
	receiver_list: $BASE_URL + 'api/my/receiver_list',
	//消息详情
	msg_detail: $BASE_URL + 'api/my/msg_detail',
	//作者专栏
	author_info: $BASE_URL + 'api/author/author_info',
	//打赏榜（查看更多小仙女） 
	book_gift_ranking: $BASE_URL + 'api/author/book_gift_ranking',
	//打赏作者
	gift_author: $BASE_URL + 'api/author/gift_author',
	//收藏作者
	collect_author: $BASE_URL + 'api/author/collect_author',
	//取消收藏
	cancel_collect: $BASE_URL + 'api/author/cancel_collect',
	//云锦金榜
	ranking_jb:  $BASE_URL + 'api/index/ranking_jb',
	
	//我的设置 -- 意见反馈类型列表
	feedback_type_list: $BASE_URL + 'api/my/feedback_type_list',
	//意见反馈
	add_feedback: $BASE_URL + 'api/my/add_feedback',
	// 问题列表
	problem_list:  $BASE_URL +  'api/my/problem_list',
	//问题回答
	problem_answer: $BASE_URL + 'api/my/problem_answer',
	
	//我的云锦币 --- 云锦币记录
	user_money_log: $BASE_URL + 'api/my/user_money_log',
	//充值记录
	user_recharge_log: $BASE_URL + 'api/my/user_recharge_log',
	//消费记录
	user_profit_log: $BASE_URL + 'api/my/user_profit_log',
	//签到页面
	signin_page: $BASE_URL + 'api/my/signin_page',
	//签到
	signin: $BASE_URL + 'api/my/signin',
	
	//消息 -- 消息详情
	msg_detail: $BASE_URL + 'api/my/msg_detail',
	//消息 -- 发送消息
	send_msg: $BASE_URL + 'api/my/send_msg',
	//消息 -- 收信人名单
	receiver_list: $BASE_URL + 'api/my/receiver_list',
	//消息 -- 获取消息
	get_user_msg: $BASE_URL + 'api/my/get_user_msg',
	//琼浆玉露
	user_gift_log: $BASE_URL + 'api/my/user_gift_log',
	
	
	//更新旧文----更新旧文页面
	get_update_books: $BASE_URL + 'api/my/get_update_books',
	//更新旧文----更新旧文详情页面
	update_books_detail: $BASE_URL + 'api/my/update_books_detail',
	//更新旧文----添加修改章节页面
	add_chapter_page: $BASE_URL + 'api/my/add_chapter_page',
	//更新旧文----添加章节
	add_chapter: $BASE_URL + 'api/my/add_chapter',
	//编辑更新
	edit_chapter: $BASE_URL + 'api/my/edit_chapter',
	//更新旧文-- 添加/编辑书本页面
	edit_book_page: $BASE_URL + 'api/my/edit_book_page',
	//更新旧文 -- 添加/修改书本
	add_book: $BASE_URL + 'api/my/add_book',
	//评论记录
	comment_list: $BASE_URL +'api/my/comment_list',
	//书本评论记录
	books_comment_list: $BASE_URL +'api/my/books_comment_list',
	//回复评论
	add_comment: $BASE_URL + 'api/book/add_comment',
	//我的评论记录
	my_comment_list: $BASE_URL + 'api/my/my_comment_list',
	//我的评论
	my_comments: $BASE_URL + 'api/my/my_comments',
	
	//收益记录
	user_income_log: $BASE_URL + 'api/my/user_income_log',
	//读者收藏用户
	collect_user: $BASE_URL + 'api/user/collect_user',
	//成为作者
	be_author: $BASE_URL + 'api/my/be_author',
	//热门话题
	hot_talk: $BASE_URL + 'api/forum/hot_talk',
	
	// -------------------------------------------------
	//论坛主页
	forum_home: $BASE_URL + 'api/forum/forum_home',
	//论坛管理区
	forum_home_gl: $BASE_URL + 'api/forum/forum_home_gl',
	//论坛板块详情
	category_detail: $BASE_URL + 'api/forum/category_detail',
	//发表新帖
	add_forum: $BASE_URL + 'api/forum/add_forum',
	//帖子详情
	forum_detail: $BASE_URL + 'api/forum/forum_detail',
	//回复帖子
	reply_forum: $BASE_URL +'api/forum/reply_forum',
	//收藏帖子
	collect_forum: $BASE_URL +'api/forum/collect_forum',
	// 帖子收藏列表
	forum_collect_list: $BASE_URL +'api/forum/forum_collect_list',
	//发表帖子列表
	my_forum_list: $BASE_URL + 'api/forum/my_forum_list',
	//最近浏览帖子
	forum_browsing: $BASE_URL + 'api/forum/forum_browsing',
	//实时论坛 -- 实时评论
	newest_comments: $BASE_URL + 'api/forum/newest_comments',
	//置顶帖子
	top_forum: $BASE_URL + 'api/forum/top_forum',
	//帖子加精
	digest_forum: $BASE_URL + 'api/forum/digest_forum',
	//删除帖子
	del_forum: $BASE_URL + 'api/forum/del_forum',
	//删除回复
	del_comment: $BASE_URL + 'api/forum/del_comment',
	//申请版主
	apply_forum_moderator: $BASE_URL + 'api/forum/apply_forum_moderator',
	//帖子搜索
	search_forum: $BASE_URL + 'api/forum/search_forum',
	
	// ------------------我的专栏设置---------------
	
	//作者专栏设置页面
	special_column_page: $BASE_URL + 'api/my/special_column_page',
	
	//编辑作者专栏设置
	edit_special_column: $BASE_URL + 'api/my/edit_special_column',
	//头像上传
	avatar_upload: $BASE_URL + 'api/my/avatar_upload',
	//获取系统封面
	getSystemCover: $BASE_URL + 'api/my/getSystemCover',
	//系统生成封面
	makeCover: $BASE_URL + 'api/my/makeCover',
	
	//获取可选充值金额
	pay_money_list: $BASE_URL + 'api/pay/pay_money_list',
	// 个人消息列表
	get_user_msg: $BASE_URL + 'api/my/user_msg_list',
	//系统消息列表
	service_msg_list: $BASE_URL + 'api/my/service_msg_list',
	//收信人名单
	receiver_list: $BASE_URL + 'api/my/receiver_list',
	//消息详情
	msg_detail: $BASE_URL + 'api/my/msg_detail',
	//发送消息
	send_msg: $BASE_URL + 'api/my/send_msg',
	
	//作者专栏 系统头像
	getUserCover: $BASE_URL +'api/my/getUserCover',
	//个人资料 系统头像
	getUserAvatar: $BASE_URL +'api/my/getUserAvatar',
	
	//作者请假
	ask_leave: $BASE_URL + 'api/my/ask_leave',
	//金榜
	ranking_jb: $BASE_URL +'api/index/ranking_jb',
	//分类
	categoryList: $BASE_URL +'api/index/categoryList',
	//收藏书单
	book_list_collect: $BASE_URL +'api/index/book_list_collect',
	
	
	//设置
	//修改密码
	reset_pwd: $BASE_URL + 'api/my/reset_pwd',
	//修改密码手机验证
	reset_code_check: $BASE_URL + 'api/my/reset_code_check',
	
	//防盗设置信息
	plrate_info: $BASE_URL +'api/my/plrate_info',
	//修改防盗信息
	plrate_edit: $BASE_URL +'api/my/plrate_edit',
	
	//购买云锦币
	createPay: $BASE_URL + 'api/pay/createPay',
	//微信授权登录
	wechat_login:  $BASE_URL +  'api/third/wechat_login',
	
	//列表页面
	plateBookList:  $BASE_URL +  'api/index/plateBookList',
	
	//删除书单
	del_books_list:  $BASE_URL +  'api/index/del_books_list',
	//刷新共享书单
	booklist_share:  $BASE_URL + 'api/index/booklist_share',
	//解锁/锁定章节 更新旧文
	lock_chapter:  $BASE_URL + 'api/book/lock_chapter',
	//修改昵称
	edit_nickname:  $BASE_URL +'api/my/edit_nickname',
	//添加卷标
	edit_volume:  $BASE_URL + 'api/book/edit_volume',
	//删除卷标
	del_volume:  $BASE_URL + 'api/book/del_volume',
	//手机号登录
	mobilelogin:  $BASE_URL + 'api/user/mobilelogin',
	
	//扎贴
	stick_forum:  $BASE_URL + 'api/forum/stick_forum',
	
	//书本 收藏章节
	collect_chapter:  $BASE_URL + 'api/book/collect_chapter',
	//重置密码
	resetpwd: $BASE_URL + 'api/user/resetpwd',
	//刷新黑马榜
	refresh_darkhorse:  $BASE_URL + 'api/index/refresh_darkhorse',
	//删除书签
	del_bookmark:  $BASE_URL + 'api/my/del_bookmark',
	
	//书本打赏榜
	gift_ranking: $BASE_URL + 'api/book/gift_ranking',
	//qq登录
	qq_login: $BASE_URL +'api/third/qq_login',
	
	//设为青少年模式
	set_young: $BASE_URL + 'api/user/set_young',
	//取消青少年模式
	cancel_young: $BASE_URL + 'api/user/cancel_young',
	
	//添加/修改收藏类别
	add_collect_type: $BASE_URL + 'api/book/add_collect_type',
	//删除收藏类别
	del_collect_type:  $BASE_URL + 'api/book/del_collect_type',
	//收藏类别列表
	collect_type_list:  $BASE_URL + 'api/book/collect_type_list',
	//收藏书籍
	collect_book:  $BASE_URL + 'api/book/collect_book',
	//书本评论列表
	book_comment_list:  $BASE_URL + 'api/book/book_comment_list',
	//删除书单中书籍
	del_from_list:  $BASE_URL + 'api/book/del_from_list',
	//设置存稿发送时间
	edit_keep_time:  $BASE_URL + 'api/my/edit_keep_time',
	//最近阅读删除
	del_history_book: $BASE_URL + 'api/index/del_history_book',
	
	// 书本评论投诉 https://www.yjwxc.com/api/book/tousu
	tousu: $BASE_URL + 'api/book/tousu',
	
	// 作者中心-申请榜单
	// 可申榜列表
	apply_book_list: $BASE_URL + 'home/zcontroller/myBookList', //'api/my/apply_book_list',
	// 提交榜单申请
	apply_book: $BASE_URL + 'home/zcontroller/applyBook', //'api/my/apply_book',
}
